import type { FaireProductEntity } from "../../entity_types/product";

export const p_cm8bq2cwhv: FaireProductEntity = {
  token: "p_cm8bq2cwhv",
  type: "product",
  name: "Heirloom Pumpkin  Fall 12oz  Icon Candle",
  brandToken: "b_ac12aam3a3",
  brandName: "The SOi Company",
  imageUrl:
    "https://cdn.faire.com/fastly/f4769b6abb15726d7b626ecf9d941146789c17ae54799398410a39a3f8196b63.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2534b1c05550a1be5ddfc053a07a8dd04f59a44cc436a29ac6b92a66f65ac00c.png",
    "https://cdn.faire.com/fastly/4c111eee542020bed4a2f56e975d0f9008c8472920cb702fd2186b1c15ce1f68.png",
    "https://cdn.faire.com/fastly/4c5aa0f29dcbc7355a7c91c8253cba6edb9cef5c20a06fdd1cb0096824212233.jpeg",
  ],
  priceDollars: 15,
  description:
    '🎃 Heirloom Pumpkin — Icon Candle\nThe Heirloom Pumpkin Icon Candle captures the heart of fall baking — cozy kitchens, golden afternoons, and that irresistible scent of something delicious in the oven. It blends the velvety richness of pumpkin custard with a swirl of warm spices, creating a fragrance that’s creamy, comforting, and perfectly autumn. It’s the kind of scent that wraps your home in soft sweaters, glowing candles, and pure seasonal nostalgia. (Colors may vary slightly due to photographic lighting and differences in monitor or screen displays).\n\n🍂 Fragrance Notes\nTop — Pumpkin Custard\nMid — Warm Spices\nBase — Soft Vanilla Cream"',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:04.513Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
